
import React, { useState } from 'react';
import { withRenderingDebug, useChildrenValidation } from "@/utils/errorDetector";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { CompletedBookingsList } from "@/components/admin/bookings/CompletedBookingsList";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { useCompletedBookings, CompletedBooking } from "@/hooks/useCompletedBookings";
import { PaymentMetricCard } from "@/components/admin/bookings/PaymentMetricCard";
import { UnifiedBookingDialog } from "@/components/booking/UnifiedBookingDialog";

const CompletedBookings = () => {
  useChildrenValidation(null, 'CompletedBookings');
  
  const { data, isLoading } = useCompletedBookings();
  const [selectedBooking, setSelectedBooking] = useState<CompletedBooking | null>(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  
  const handleViewDetails = (booking: CompletedBooking) => {
    // Transform CompletedBooking to the format expected by UnifiedBookingDialog
    const transformedBooking = {
      id: booking.booking_id,
      service_name: booking.service_name,
      customer_name: booking.customer_name,
      start_time: booking.booking_start_time,
      status: 'completed',
      comment: booking.comment
    };
    
    setSelectedBooking(transformedBooking as any);
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
    setSelectedBooking(null);
  };
  
  return (
    <AdminLayout title="Completed Bookings">
      <div className="space-y-6">
        {isLoading ? (
          <Card>
            <CardContent className="pt-6">
              <Skeleton className="h-20 w-full" />
            </CardContent>
          </Card>
        ) : (
          <PaymentMetricCard completions={data || []} />
        )}
        
        {isLoading ? (
          <Card>
            <CardContent className="pt-6">
              <Skeleton className="h-40 w-full" />
            </CardContent>
          </Card>
        ) : (
          <CompletedBookingsList 
            data={data || []} 
            onViewDetails={handleViewDetails}
          />
        )}
        
        <UnifiedBookingDialog
          isOpen={isDialogOpen}
          onClose={handleCloseDialog}
          booking={selectedBooking}
          isAdminView={true}
        />
      </div>
    </AdminLayout>
  );
};

export default withRenderingDebug(CompletedBookings, 'CompletedBookings');
